import { DeliveryPriority } from "modules/deliveryPriority";

const DeliveryPriorityPage = () => {
  return <DeliveryPriority />;
};

export default DeliveryPriorityPage;
